import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;

  return {
    summary: {
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: 10
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 16,
      fontSize: fontSize.body
    },
    total: {
      paddingTop: 12,
      marginTop: 2,
      boxShadow: `inset 0 1px 0 ${color.line}`,
      "& $label, & $value": {
        fontSize: fontSize.lead,
        fontWeight: 800,
        color: color.ink
      }
    },
    label: {
      margin: 0,
      color: color.text2
    },
    value: {
      margin: 0,
      fontWeight: 600,
      color: color.ink,
      textAlign: "right",
      whiteSpace: "nowrap"
    },
    success: {
      color: color.success
    },
    navRow: {
      appearance: "none",
      border: 0,
      margin: 0,
      font: "inherit",
      background: "none",
      width: "100%",
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      gap: 14,
      minHeight: 64,
      padding: "10px 12px",
      borderRadius: radius.tile,
      color: color.ink,
      textDecoration: "none",
      boxSizing: "border-box"
    },
    interactive: {
      cursor: "pointer",
      "&:hover": { backgroundColor: color.surface, color: color.ink }
    },
    disc: {
      width: 40,
      height: 40,
      flex: "none",
      borderRadius: radius.pill,
      backgroundColor: color.surface,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg": { fontSize: theme.tokens.iconSize.md }
    },
    rowBody: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      flex: 1,
      minWidth: 0
    },
    rowTitle: {
      fontSize: fontSize.body,
      fontWeight: 700
    },
    rowSub: {
      fontSize: fontSize.small,
      color: color.muted
    },
    chevron: {
      display: "flex",
      color: color.muted
    }
  };
});

export default withCustomStyles;
